import { render, staticRenderFns } from "./DxDescriptionLabel.vue?vue&type=template&id=7ede715e&scoped=true&"
import script from "./DxDescriptionLabel.vue?vue&type=script&lang=js&"
export * from "./DxDescriptionLabel.vue?vue&type=script&lang=js&"
import style0 from "./DxDescriptionLabel.vue?vue&type=style&index=0&id=7ede715e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ede715e",
  null
  
)

export default component.exports